import HeaderPortal from "components/portal/header-portal";
import CreateItemButton from "components/buttons/create";
import List from "components/list";
import { PermissionControlledInput } from "permissions/components/input";
import { CommonCell } from "components/index";

export default function Tools() {

    const columns = [
        {
            id: "name",
            header: "Name",
            accessorKey: "name",
            cell: (props) => <CommonCell {...props} collection="tools" field="name" />,
            sortable: true,
        },
        {
            id: "type",
            header: "Type",
            accessorKey: "type",
            cell: (props) => <CommonCell {...props} collection="tools" field="type" />,
        },
    ];

    const fields = ["id", "name", "type"];


    return (
        <div className="w-full">
            <HeaderPortal>
                <PermissionControlledInput
                    rule={"create:*"}
                    collection="tools"
                    showWhenDisabled={false}
                >
                    <CreateItemButton href>Tool</CreateItemButton>
                </PermissionControlledInput>
            </HeaderPortal>
            <div className="flex-1 h-full">
                <List
                    title="Tools"
                    endPoint="tools"
                    storagekey="tools"
                    perPage={100}
                    columns={columns}
                    meta={{ fields }}
                    sortBy="name"
                    sortOrder="aesc"
                    hidePagination={true}
                    href={(item) => item.id}
                    rowClassName="h-13"
                />
            </div>
        </div>
    );
}
